import { get, put } from './base/index';
import { API, getUserId } from '../helpers';

export default {
  getConfig: () => get(`${API}/settings/${getUserId()}`),
  updateConfig: (form) => put(`${API}/settings/${getUserId()}`, form),
};
